package pl.nickers.match3

data class UserProfile(
    val userId: String,
    val displayName: String,
    val highScore: Int,
    val highestUnlockedLevel: Int,
    val lifetimeLevelsCompleted: Int,
    val gems: Int,
    val lifetimePowerUpsBomb: Int,
    val lifetimePowerUpsRowBomb: Int,
    val lifetimePowerUpsTargetedRemove: Int,
)
